import { any, async, fromJSX, loadingAsyncState, nothing } from "widgets-for-react";
import { fetchSearchResults } from "./searchPageApi";
import { SearchPageLayout } from "./searchPageLayout";
import { emptySearchResult } from "./searchPageState";
import { updateQueryParams } from "../../util";
export const SearchPageWidget = (props)=>{
    return any()([
        fromJSX((setState)=>{
            return SearchPageLayout({
                ...props,
                updateQuery: (searchQuery)=>setState((prevState)=>({
                            ...prevState,
                            searchQuery
                        })),
                updatePage: (currentPage)=>setState((prevState)=>({
                            ...prevState,
                            currentPage,
                            searchResults: loadingAsyncState(fetchSearchResults(prevState.searchQuery, currentPage, prevState.pageSize), previousResult(prevState))
                        })),
                runQuery: ()=>setState((prevState)=>{
                        updateQueryParams('query', prevState.searchQuery); // Update URL Query params
                        return newLoadingQuery(prevState.searchQuery, prevState);
                    })
            });
        }),
        async(nothing, {
            key: 'searchResultLoader'
        })(props.searchResults).map((resultUpdater)=>(s0)=>{
                const searchResults = resultUpdater(s0.searchResults);
                if (searchResults.kind == 'loaded') scrollResultsToTop();
                return {
                    ...s0,
                    searchResults
                };
            })
    ]).map((a)=>a(props));
};
export const newLoadingQuery = (searchQuery, prevState)=>({
        ...prevState,
        searchQuery,
        currentPage: 1,
        searchResults: loadingAsyncState(fetchSearchResults(searchQuery, 1, prevState.pageSize), previousResult(prevState))
    });
const previousResult = (s0)=>s0.searchResults.kind == 'loaded' || s0.searchResults.kind == 'loading' ? s0.searchResults.value : emptySearchResult;
const scrollResultsToTop = ()=>document.getElementsByClassName("search-results")[0].scrollIntoView({
        behavior: "smooth"
    });
